import { getAllInboundApplicationForms, getInboundFormsConversionRates } from '@/services/inboundForm.service';
import {
  INBOUND_APPLICATION_SORT_BY,
  INBOUND_APPLICATION_SORT_ORDER,
} from '@Saral-Influencer-Marketing/saral-utils/src/constants/inboundApplication';

import { getAvailablePlatforms, getInboundApplicationList } from '../../services/inbound.service';
import { applicationFetchLimit } from '../../utils/constants';
import {
  EVICT_APPLICATION_CACHE,
  FETCH_ALL_INBOUND_FORMS,
  FETCH_APPLICATION_FORM_CONVERSION_RATES_REQUEST,
  FETCH_APPLICATION_FORM_CONVERSION_RATES_SUCCESS,
  FETCH_APPLICATION_REQUEST,
  FETCH_APPLICATION_SUCCESS,
  FETCH_AVAILABLE_PLATFORMS_SUCCESS,
  SET_APPLICATION_COUNT,
} from './applicationType';

export const fetchApplicationsRequest = () => {
  return {
    type: FETCH_APPLICATION_REQUEST,
  };
};

export const fetchApplicationsSuccess = (applications) => {
  return {
    type: FETCH_APPLICATION_SUCCESS,
    payload: applications,
  };
};

export const setApplicationCount = ({ count, approvalStatus }) => {
  return {
    type: SET_APPLICATION_COUNT,
    payload: {
      count,
      approvalStatus,
    },
  };
};

export const evictApplicationsCache = () => {
  return {
    type: EVICT_APPLICATION_CACHE,
  };
};

export const setAllInboundApplicationForms = (forms) => {
  return {
    type: FETCH_ALL_INBOUND_FORMS,
    payload: forms,
  };
};

export const fetchApplicationsFormsConversionRateRequest = () => {
  return {
    type: FETCH_APPLICATION_FORM_CONVERSION_RATES_REQUEST,
  };
};

export const setInboundFormsConversionRatesSuccess = (payload) => {
  return {
    type: FETCH_APPLICATION_FORM_CONVERSION_RATES_SUCCESS,
    payload,
  };
};

export const fetchAvailablePlatformsSuccess = (payload) => {
  return {
    type: FETCH_AVAILABLE_PLATFORMS_SUCCESS,
    payload,
  };
};

export const evictApplicationsAndRefetch =
  ({ approvalStatus, formIds }) =>
  (dispatch) => {
    dispatch(fetchApplicationsRequest());
    dispatch(evictApplicationsCache());
    dispatch(fetchApplications({ approvalStatus, formIds }));
  };

export const fetchApplications = (args) => {
  return async (dispatch) => {
    const approvalStatus = args?.approvalStatus || 'pending';
    const pageSize = args?.pageSize || applicationFetchLimit;
    const currentPage = args?.currentPage || 1;
    const formIds = args?.formIds || [];
    const searchQuery = args?.searchQuery || '';
    const platform = args?.platform || '';
    const followers = args?.followers || {};
    const sortBy = args?.sortBy || '';
    const sortOrder = args?.sortOrder || '';

    if (approvalStatus === 'product-requests') {
      return;
    }

    dispatch(fetchApplicationsRequest());

    let body = {
      approvalStatus,
      pageSize,
      currentPage,
      formIds,
    };

    if (platform) {
      body.platform = platform;
    }

    if (followers?.min && followers?.max) {
      body.followers = followers;
    }

    if (searchQuery && searchQuery?.length > 0) {
      body.searchQuery = searchQuery;
    }

    if (sortBy && sortOrder) {
      body.sortBy = sortBy;
      body.sortOrder = sortOrder;
    }

    const response = await getInboundApplicationList(body);
    if (response?.status) {
      dispatch(
        fetchApplicationsSuccess({
          applications: response.data.inboundApplicationList,
        })
      );

      dispatch(setApplicationCount({ count: response.data.total, approvalStatus }));
    } else {
      dispatch(fetchApplicationsSuccess({ applications: [] }));
    }
  };
};

export const fetchAllInboundApplicationForms = () => {
  return async (dispatch) => {
    const response = await getAllInboundApplicationForms();
    if (response?.status) {
      dispatch(setAllInboundApplicationForms(response.data));
    }
  };
};

export const fetchInboundFormConversionRates = (formIds) => {
  return async (dispatch) => {
    dispatch(fetchApplicationsFormsConversionRateRequest());
    const response = await getInboundFormsConversionRates({ formIds });
    if (response?.status) {
      dispatch(setInboundFormsConversionRatesSuccess(response.data));
    }
  };
};

export const fetchAvailablePlatforms = () => {
  return async (dispatch) => {
    const response = await getAvailablePlatforms();
    if (response?.status) {
      dispatch(fetchAvailablePlatformsSuccess(response.data));
    }
  };
};
